import { useSplitEnabled } from '@buffer-mono/features'

import { LinkedInCapabilitiesLaunchDialogContent } from './LinkedInCapabilitiesLaunchDialogContent'

import type { JSX } from 'react'

/**
 * Publish-native LinkedIn Capabilities launch dialog. Gates on the
 * `linkedin-verified-skills` split (waiting for `isReady` before reading
 * `isEnabled`, so it never flashes during SDK load) and defers all trigger
 * logic + UI to the inner content component.
 *
 * Migrated out of app-shell (CORE-6165) so it observes route changes via
 * Publish's own React Router instead of the since-removed `window.__history` bridge.
 */
export function LinkedInCapabilitiesLaunchDialog(): JSX.Element | null {
  const { isEnabled, isReady } = useSplitEnabled('linkedin-verified-skills')

  if (!isReady || !isEnabled) {
    return null
  }

  return <LinkedInCapabilitiesLaunchDialogContent />
}
